import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { AuthProvider } from './lib/AuthContext';
// app.css is the single source of truth for all styling — tokens, layout
// grid, components, animations, and print rules.
import './styles/app.css';

// StrictMode disabled — its dev-only double-invocation of effects kept
// remounting ProjectCard components mid-animation, restarting the entrance
// transition from opacity 0. Production builds don't double-invoke, so
// the deployed site behaves correctly with StrictMode enabled or disabled.
ReactDOM.createRoot(document.getElementById('root')!).render(
  <BrowserRouter>
    <AuthProvider>
      <App />
    </AuthProvider>
  </BrowserRouter>,
);
